import React, { useState } from "react";
import { Mail, MessageSquare } from "lucide-react";
import { toast } from "sonner";
import Reveal from "../components/Reveal";
import { useSeo, breadcrumbLd } from "../lib/seo";

export default function Contact() {
  const [sent, setSent] = useState(false);
  useSeo({
    title: "Contact",
    description: "Get in touch with the Aesthetiq team for support, partnerships or press.",
    path: "/contact",
    jsonLd: breadcrumbLd([{ name: "Home", path: "/" }, { name: "Contact", path: "/contact" }]),
  });

  const submit = (e) => {
    e.preventDefault();
    setSent(true);
    toast.success("Message sent — we'll reply within 1 business day.");
  };

  return (
    <div className="container max-w-2xl py-16">
      <Reveal>
        <span className="label-eyebrow">Contact</span>
        <h1 className="mt-3 font-display text-5xl">Let's talk.</h1>
        <p className="mt-4 text-muted-foreground">Questions, feedback, partnerships or press — drop us a line.</p>

        <div className="mt-8 grid gap-4 sm:grid-cols-2">
          <a href="mailto:hello@selfiecheckup.com" className="flex items-center gap-3 rounded-xl border border-border bg-card p-5 transition hover:border-primary/40">
            <Mail className="h-5 w-5 text-primary" />
            <div><p className="text-sm font-medium">Email</p><p className="text-xs text-muted-foreground">hello@selfiecheckup.com</p></div>
          </a>
          <div className="flex items-center gap-3 rounded-xl border border-border bg-card p-5">
            <MessageSquare className="h-5 w-5 text-primary" />
            <div><p className="text-sm font-medium">Support</p><p className="text-xs text-muted-foreground">Avg reply &lt; 1 business day</p></div>
          </div>
        </div>

        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="contact-form">
          <div className="grid gap-4 sm:grid-cols-2">
            <input required placeholder="Name" data-testid="contact-name" className="rounded-md border border-border bg-card px-4 py-3 text-sm outline-none focus:border-primary/60" />
            <input required type="email" placeholder="Email" data-testid="contact-email" className="rounded-md border border-border bg-card px-4 py-3 text-sm outline-none focus:border-primary/60" />
          </div>
          <textarea required rows={5} placeholder="How can we help?" data-testid="contact-message" className="w-full rounded-md border border-border bg-card px-4 py-3 text-sm outline-none focus:border-primary/60" />
          <button type="submit" disabled={sent} data-testid="contact-submit" className="rounded-md bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground transition hover:brightness-110 disabled:opacity-60">
            {sent ? "Sent ✓" : "Send message"}
          </button>
        </form>
      </Reveal>
    </div>
  );
}
